// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\Auth\Ability\Subjects\DataProviders\AbilitySubject
// Generated on: <normalized>

export enum AbilitySubject {
  TENANT_USERS = 'TenantUsers',
  TENANT_USERS_LOAD_NEW = 'TenantUsers:Load:New',
  TENANT_USERS_GUID = 'TenantUsers:Guid',
  TENANT_USERS_UPDATE_GUID = 'TenantUsers:Update:Guid',
  TENANT_USERS_DELETE_GUID = 'TenantUsers:Delete:Guid',
  TENANT_ROLES = 'TenantRoles',
  TENANT_ROLES_LOAD_NEW = 'TenantRoles:Load:New',
  TENANT_ROLES_GUID = 'TenantRoles:Guid',
  TENANT_ROLES_UPDATE_GUID = 'TenantRoles:Update:Guid',
  TENANT_ROLES_DELETE_GUID = 'TenantRoles:Delete:Guid',
  TENANT_ROLE_PERMISSIONS = 'TenantRolePermissions',
  TENANT_ROLE_PERMISSIONS_LOAD_NEW = 'TenantRolePermissions:Load:New',
  TENANT_ROLE_PERMISSIONS_GUID = 'TenantRolePermissions:Guid',
  TENANT_ROLE_PERMISSIONS_UPDATE_GUID = 'TenantRolePermissions:Update:Guid',
  TENANT_ROLE_PERMISSIONS_DELETE_GUID = 'TenantRolePermissions:Delete:Guid',
  TENANT_PERMISSION_DEFINITIONS = 'TenantPermissionDefinitions',
  TENANT_PERMISSION_DEFINITIONS_LOAD_NEW = 'TenantPermissionDefinitions:Load:New',
  TENANT_PERMISSION_DEFINITIONS_GUID = 'TenantPermissionDefinitions:Guid',
  TENANT_PERMISSION_DEFINITIONS_UPDATE_GUID = 'TenantPermissionDefinitions:Update:Guid',
  TENANT_PERMISSION_DEFINITIONS_DELETE_GUID = 'TenantPermissionDefinitions:Delete:Guid',
  AI_THREADS = 'Ai:Threads',
  AI_FEEDBACK = 'Ai:Feedback',
  AI_FEEDBACK_GUID = 'Ai:Feedback:Guid',
  AUTH_LOGIN = 'Auth:Login',
  AUTH_LOBBY = 'Auth:Lobby',
  AUTH_WAITING = 'Auth:Waiting',
  AUTH_NOT_AUTHORIZED = 'Auth:Not:Authorized',
  AUTH_FORGOT_PASSWORD = 'Auth:Forgot:Password',
  AUTH_SET_PASSWORD = 'Auth:Set:Password',
  DASHBOARDS_ECOMMERCE = 'Dashboards:Ecommerce',
  BANKING_JOURNALS_LOAD_NEW = 'Banking:Journals:Load:New',
  BANKING_JOURNALS = 'Banking:Journals',
  BANKING_JOURNALS_GUID = 'Banking:Journals:Guid',
  BANKING_JOURNALS_UPDATE_GUID = 'Banking:Journals:Update:Guid',
  BANKING_JOURNALS_DELETE_GUID = 'Banking:Journals:Delete:Guid',
  BANKING_RECONCILIATION_PROPOSALS = 'Banking:Reconciliation:Proposals',
  BANKING_RECONCILIATION_PROPOSALS_GUID = 'Banking:Reconciliation:Proposals:Guid',
  BANKING_RECONCILIATION_GUID = 'Banking:Reconciliation:Guid',
  BANK_ACCOUNTS_LOAD_NEW = 'BankAccounts:Load:New',
  BANK_ACCOUNTS = 'BankAccounts',
  BANK_ACCOUNTS_GUID = 'BankAccounts:Guid',
  BANK_ACCOUNTS_UPDATE_GUID = 'BankAccounts:Update:Guid',
  BANK_ACCOUNTS_DELETE_GUID = 'BankAccounts:Delete:Guid',
  EMPLOYEES_DIRECTORY_READ = 'Employees:Directory:Read',
  EMPLOYEES_DIRECTORY_MANAGE = 'Employees:Directory:Manage',
  ORDERS = 'Orders',
  ORDERS_CREATE = 'Orders:Create',
  ORDERS_UPDATE_GUID = 'Orders:Update:Guid',
  ORDERS_PREVIEW_SERVICE = 'Orders:Preview:Service',
  ORDERS_PREVIEW_GUID = 'Orders:Preview:Guid',
  ORDERS_PREVIEW_ALL = 'Orders:Preview:All',
  ORDERS_SEARCH = 'Orders:Search',
  ORDERS_INVOICES = 'Orders:Invoices:Guid',
  ORDERS_TABLE_SHORTCUTS = 'Orders:Table:Shortcuts',
  ORDERS_ACTIONS_SET_INACTIVE = 'Orders:Actions:Set:Inactive',
  ORDERS_UPDATE_CALENDAR_ENTRY = 'Orders:Update:Calendar:Guid',
  INVOICES = 'Invoices',
  INVOICES_PREVIEW_SERVICE = 'Invoices:Preview:Service',
  INVOICES_PREVIEW_ALL = 'Invoices:Preview:All',
  INVOICES_CREATE = 'Invoices:Create',
  INVOICES_UPDATE_GUID = 'Invoices:Update:Guid',
  INVOICES_PREVIEW_GUID = 'Invoices:Preview:Guid',
  INVOICES_REFUND_GUID = 'Invoices:Refund:Guid',
  INVOICES_SEARCH = 'Invoices:Search',
  INVOICES_RECONSILE = 'Invoices:Reconsile',
  INVOICES_MESSAGE = 'Invoices:Message',
  INVOICES_TABLE_SHORTCUTS = 'Invoices:Table:Shortcuts',
  INVOICES_ACTIONS_SET_INACTIVE = 'Invoices:Actions:Set:Inactive',
  QUOTES = 'Quotes',
  QUOTES_PREVIEW_SERVICE = 'Quotes:Preview:Service',
  QUOTES_PREVIEW_ALL = 'Quotes:Preview:All',
  QUOTES_PREVIEW_GUID = 'Quotes:Preview:Guid',
  QUOTES_CALENDAR_SIDEBAR = 'Quotes:Calendar:Sidebar',
  QUOTES_SEARCH = 'Quotes:Search',
  QUOTES_MESSAGE = 'Quotes:Message',
  QUOTES_CREATE = 'Quotes:Create',
  QUOTES_UPDATE_GUID = 'Quotes:Update:Guid',
  QUOTES_TABLE_SHORTCUTS = 'Quotes:Table:Shortcuts',
  QUOTES_INVOICES_TOOL = 'Quotes:Invoices:Tool',
  QUOTES_ACTIONS_SET_INACTIVE = 'Quotes:Actions:Set:Inactive',
  QUOTES_ACTIONS_SET_PO = 'Quotes:Actions:Set:PurchaseOrder',
  JOBTYPES_PREVIEW_ALL = 'JobTypes:Preview:All',
  JOBTYPES_CREATE = 'JobTypes:Create',
  JOBTYPES_PREVIEW_GUID = 'JobTypes:Preview:Guid',
  JOBTYPES_TABLE_SHORTCUTS = 'JobTypes:Table:Shortcuts',
  PROJECTS_PREVIEW_ALL = 'Projects:Preview:All',
  PROJECTS_PREVIEW_GUID = 'Projects:Preview:Guid',
  PROJECTS_CREATE = 'Projects:Create',
  ASSETS_PREVIEW_ALL = 'Assets:Preview:All',
  ASSETS_PREVIEW_GUID = 'Assets:Preview:Guid',
  ASSETS_CREATE = 'Assets:Create',
  ASSETS_TABLE_SHORTCUTS = 'Assets:Table:Shortcuts',
  ASSETS_SERVICES_PREVIEW_ALL = 'Assets:Services:Preview:All',
  ASSETS_SERVICES_PREVIEW_GUID = 'Assets:Services:Guid',
  ASSETS_SERVICES_UPDATE_GUID = 'Assets:Services:Update:Guid',
  ASSETS_SERVICES_CREATE = 'Assets:Services:Create',
  ASSETS_INSPECTIONS_PREVIEW_ALL = 'Assets:Inspections:Preview:All',
  ASSETS_INSPECTIONS_PREVIEW_GUID = 'Assets:Inspections:Guid',
  ASSETS_INSPECTIONS_UPDATE_GUID = 'Assets:Inspections:Update:Guid',
  ASSETS_INSPECTIONS_CREATE = 'Assets:Inspections:Create',
  CALENDAR_CREATE = 'Calendar:Create',
  CALENDAR_CREATE_RULE = 'Calendar:Create:Rule',
  CALENDAR_DELETE_RULE = 'Calendar:Delete:Rule',
  CALENDAR_CREATE_QUOTE = 'Calendar:Create:Quote',
  CALENDAR_PREVIEW_ALL = 'Calendar:Preview:All',
  CUSTOMERS_PREVIEW_ALL = 'Customers:Preview:All',
  CUSTOMERS_PREVIEW_GUID = 'Customers:Guid',
  CUSTOMERS_UPDATE_GUID = 'Customers:Update:Guid',
  CUSTOMERS_CREATE = 'Customers:Create',
  CUSTOMERS_TABLE_SHORTCUTS = 'Customers:Table:Shortcuts',
  MESSAGES_TABLE_TOOL = 'Messages:Table:Tool',
  MESSAGES_PREVIEW_ALL = 'Messages:Preview:All',
  MESSAGES_CREATE = 'Messages:Create',
  MESSAGES_PREVIEW_GUID = 'Messages:Guid',
  MESSAGES_SEARCH = 'Messages:Search',
  MESSAGES_UPDATE_GUID = 'Messages:Update:Guid',
  MESSAGES_TABLE_SHORTCUTS = 'Messages:Table:Shortcuts',
  MESSAGES_APPROVALS = 'Messages:Approvals',
  MESSAGES_APPROVALS_GUID = 'Messages:Approvals:Guid',
  MESSAGES_TEMPLATES_PREVIEW_ALL = 'Messages:Templates:Preview:All',
  MESSAGES_TEMPLATES_PREVIEW_GUID = 'Messages:Templates:Guid',
  MESSAGES_THEMES_PREVIEW_ALL = 'Messages:Themes:Preview:All',
  MESSAGES_THEMES_PREVIEW_GUID = 'Messages:Themes:Preview:Guid',
  MESSAGES_THEMES_UPDATE_GUID = 'Messages:Themes:Update:Guid',
  MICROSOFTOAUTH_SETTINGS = 'MicrosoftOAuth:Settings',
  BOOKINGRULES_PREVIEW_ALL = 'BookingRules:Preview:All',
  BOOKINGRULES_PREVIEW_GUID = 'BookingRules:Preview:Guid',
  BUSINESSES_PREVIEW_ALL = 'Businesses:Preview:All',
  BUSINESSES_PREVIEW_GUID = 'Businesses:Preview:Guid',
  BUSINESSES_UPDATE_GUID = 'Businesses:Guid',
  BUSINESSES_CREATE = 'Businesses:Create',
  BUSINESSES_TABLE_SHORTCUTS = 'Businesses:Table:Shortcuts',
  REVENUESTREAMS_PREVIEW_ALL = 'RevenueStreams:Preview:All',
  REVENUESTREAMS_PREVIEW_GUID = 'RevenueStreams:Preview:Guid',
  REVENUESTREAMS_UPDATE_GUID = 'RevenueStreams:Guid',
  REVENUESTREAMS_CREATE = 'RevenueStreams:Create',
  REVENUESTREAMS_TABLE_SHORTCUTS = 'RevenueStreams:Table:Shortcuts',
  TOOLS_HOARDINGS_PLAN_CREATOR = 'Tools:Hoardings:Plan:Creator',
  PRODUCTS_PREVIEW_ALL = 'Products:Preview:All',
  PRODUCTS_PREVIEW_GUID = 'Products:Preview:Guid',
  PRODUCTS_CATEGORIES_PREVIEW_ALL = 'Products:Categories:Preview:All',
  PRODUCTS_BOOKINGOPTIONS_PREVIEW_ALL = 'Products:BookingOptions:Preview:All',
  PRODUCTS_BOOKINGOPTIONS_SELECTIONS_PREVIEW_ALL = 'Products:BookingOptions:Selections:Preview:All',
  EMAILACCOUNTS_PREVIEW_ALL = 'EmailAccounts:Preview:All',
  EVENTS_PREVIEW_ALL = 'Events:Preview:All',
  PERMISSIONSLIBRARY_PREVIEW_ALL = 'Kernal:Permissions:Preview:All',
  PERMISSIONSLIBRARY_PREVIEW_GUID = 'Kernal:Permissions:Preview',
  PERMISSIONSLIBRARY_CREATE = 'Kernal:Permissions:Create',
  PERMISSIONSLIBRARY_UPDATE_GUID = 'Kernal:Permissions:Update',
  PERMISSIONSLIBRARY_DELETE_GUID = 'Kernal:Permissions:Delete',
  PERMISSIONSLIBRARY_SEARCH = 'Kernal:Permissions:Search',
  PERMISSIONSLIBRARY_BULK_IMPORT = 'Kernal:Permissions:BulkImport',
  PERMISSIONSLIBRARY_VALIDATE_ENDPOINT = 'Kernal:Permissions:ValidateEndpoint',
  PERMISSIONSLIBRARY_VIEW_USAGE = 'Kernal:Permissions:ViewUsage',
  PERMISSIONSLIBRARY_TABLE_SHORTCUTS = 'Kernal:Permissions:Table:Shortcuts',
  SITES_LOAD_NEW = 'Sites:load_new',
  SITES = 'Sites',
  SITES_GUID = 'Sites:Guid',
  SITES_UPDATE_GUID = 'Sites:Update:Guid',
  SITES_DELETE_GUID = 'Sites:Delete:Guid',
  SITES_GUID_THEME = 'Sites:Guid:Theme',
  SITES_GUID_BOOTSTRAP = 'Sites:Guid:Bootstrap',
  GOOGLE_PLACES_SETTINGS_LOAD_NEW = 'GooglePlacesSettings:load_new',
  GOOGLE_PLACES_SETTINGS = 'GooglePlacesSettings',
  GOOGLE_PLACES_SETTINGS_GUID = 'GooglePlacesSettings:Guid',
  GOOGLE_PLACES_SETTINGS_UPDATE_GUID = 'GooglePlacesSettings:Update:Guid',
  GOOGLE_PLACES_SETTINGS_DELETE_GUID = 'GooglePlacesSettings:Delete:Guid',
  GOOGLE_PLACES_SETTINGS_MERGED_SITE = 'GooglePlacesSettings:Merged:Site:Guid',
  GOOGLE_PLACES_SETTINGS_MERGED_PRODUCT = 'GooglePlacesSettings:Merged:Product:Guid',
  GOOGLE_PLACES_SETTINGS_OWNER = 'GooglePlacesSettings:Owner:*:Guid',
  FILES_UPLOADS_LOAD_NEW = 'Files:Uploads:load_new',
  FILES_UPLOADS = 'Files:Uploads',
  FILES_UPLOADS_GUID = 'Files:Uploads:Guid',
  FILES_UPLOADS_UPDATE_GUID = 'Files:Uploads:Update:Guid',
  FILES_UPLOADS_DELETE_GUID = 'Files:Uploads:Delete:Guid',
  FILES_PROCESSING_JOBS_GUID = 'Files:Processing:Jobs:Guid',
  SBR_SUBMISSIONS = 'Sbr:Submissions',
  SBR_SUBMISSIONS_GUID = 'Sbr:Submissions:Guid',
  SBR_ACTIVITY_STATEMENTS_GET = 'Sbr:ActivityStatements:Get',
  SBR_ACTIVITY_STATEMENTS_VALIDATE = 'Sbr:ActivityStatements:Validate',
  SBR_ACTIVITY_STATEMENTS_SUBMIT = 'Sbr:ActivityStatements:Submit',
  BLANKS_PREVIEW_ALL = 'Blanks:Preview:All',
  BLANKS_PREVIEW_GUID = 'Blanks:Guid',
  BLANKS_UPDATE_GUID = 'Blanks:Update:Guid',
  BLANKS_CREATE = 'Blanks:Create',
  SERVER_META = 'Server:Meta',
  SITEPAGES_PREVIEW_ALL = 'SitePages:Preview:All',
  SITEPAGES_PREVIEW_GUID = 'SitePages:Preview:Guid',
  SITEPAGES_CREATE = 'SitePages:Create',
  SITEPAGES_UPDATE_GUID = 'SitePages:Update:Guid',
  SITEPAGES_ARCHIVE_GUID = 'SitePages:Archive:Guid',
  SITEPAGES_PUBLISH_GUID = 'SitePages:Publish:Guid',
  SITEPAGES_RUNTIME_SNAPSHOT = 'SitePages:RuntimeSnapshot',
}

export const AbilitySubjectCases = ["TenantUsers", "TenantUsers:Load:New", "TenantUsers:Guid", "TenantUsers:Update:Guid", "TenantUsers:Delete:Guid", "TenantRoles", "TenantRoles:Load:New", "TenantRoles:Guid", "TenantRoles:Update:Guid", "TenantRoles:Delete:Guid", "TenantRolePermissions", "TenantRolePermissions:Load:New", "TenantRolePermissions:Guid", "TenantRolePermissions:Update:Guid", "TenantRolePermissions:Delete:Guid", "TenantPermissionDefinitions", "TenantPermissionDefinitions:Load:New", "TenantPermissionDefinitions:Guid", "TenantPermissionDefinitions:Update:Guid", "TenantPermissionDefinitions:Delete:Guid", "Ai:Threads", "Ai:Feedback", "Ai:Feedback:Guid", "Auth:Login", "Auth:Lobby", "Auth:Waiting", "Auth:Not:Authorized", "Auth:Forgot:Password", "Auth:Set:Password", "Dashboards:Ecommerce", "Banking:Journals:Load:New", "Banking:Journals", "Banking:Journals:Guid", "Banking:Journals:Update:Guid", "Banking:Journals:Delete:Guid", "Banking:Reconciliation:Proposals", "Banking:Reconciliation:Proposals:Guid", "Banking:Reconciliation:Guid", "BankAccounts:Load:New", "BankAccounts", "BankAccounts:Guid", "BankAccounts:Update:Guid", "BankAccounts:Delete:Guid", "Employees:Directory:Read", "Employees:Directory:Manage", "Orders", "Orders:Create", "Orders:Update:Guid", "Orders:Preview:Service", "Orders:Preview:Guid", "Orders:Preview:All", "Orders:Search", "Orders:Invoices:Guid", "Orders:Table:Shortcuts", "Orders:Actions:Set:Inactive", "Orders:Update:Calendar:Guid", "Invoices", "Invoices:Preview:Service", "Invoices:Preview:All", "Invoices:Create", "Invoices:Update:Guid", "Invoices:Preview:Guid", "Invoices:Refund:Guid", "Invoices:Search", "Invoices:Reconsile", "Invoices:Message", "Invoices:Table:Shortcuts", "Invoices:Actions:Set:Inactive", "Quotes", "Quotes:Preview:Service", "Quotes:Preview:All", "Quotes:Preview:Guid", "Quotes:Calendar:Sidebar", "Quotes:Search", "Quotes:Message", "Quotes:Create", "Quotes:Update:Guid", "Quotes:Table:Shortcuts", "Quotes:Invoices:Tool", "Quotes:Actions:Set:Inactive", "Quotes:Actions:Set:PurchaseOrder", "JobTypes:Preview:All", "JobTypes:Create", "JobTypes:Preview:Guid", "JobTypes:Table:Shortcuts", "Projects:Preview:All", "Projects:Preview:Guid", "Projects:Create", "Assets:Preview:All", "Assets:Preview:Guid", "Assets:Create", "Assets:Table:Shortcuts", "Assets:Services:Preview:All", "Assets:Services:Guid", "Assets:Services:Update:Guid", "Assets:Services:Create", "Assets:Inspections:Preview:All", "Assets:Inspections:Guid", "Assets:Inspections:Update:Guid", "Assets:Inspections:Create", "Calendar:Create", "Calendar:Create:Rule", "Calendar:Delete:Rule", "Calendar:Create:Quote", "Calendar:Preview:All", "Customers:Preview:All", "Customers:Guid", "Customers:Update:Guid", "Customers:Create", "Customers:Table:Shortcuts", "Messages:Table:Tool", "Messages:Preview:All", "Messages:Create", "Messages:Guid", "Messages:Search", "Messages:Update:Guid", "Messages:Table:Shortcuts", "Messages:Approvals", "Messages:Approvals:Guid", "Messages:Templates:Preview:All", "Messages:Templates:Guid", "Messages:Themes:Preview:All", "Messages:Themes:Preview:Guid", "Messages:Themes:Update:Guid", "MicrosoftOAuth:Settings", "BookingRules:Preview:All", "BookingRules:Preview:Guid", "Businesses:Preview:All", "Businesses:Preview:Guid", "Businesses:Guid", "Businesses:Create", "Businesses:Table:Shortcuts", "RevenueStreams:Preview:All", "RevenueStreams:Preview:Guid", "RevenueStreams:Guid", "RevenueStreams:Create", "RevenueStreams:Table:Shortcuts", "Tools:Hoardings:Plan:Creator", "Products:Preview:All", "Products:Preview:Guid", "Products:Categories:Preview:All", "Products:BookingOptions:Preview:All", "Products:BookingOptions:Selections:Preview:All", "EmailAccounts:Preview:All", "Events:Preview:All", "Kernal:Permissions:Preview:All", "Kernal:Permissions:Preview", "Kernal:Permissions:Create", "Kernal:Permissions:Update", "Kernal:Permissions:Delete", "Kernal:Permissions:Search", "Kernal:Permissions:BulkImport", "Kernal:Permissions:ValidateEndpoint", "Kernal:Permissions:ViewUsage", "Kernal:Permissions:Table:Shortcuts", "Sites:load_new", "Sites", "Sites:Guid", "Sites:Update:Guid", "Sites:Delete:Guid", "Sites:Guid:Theme", "Sites:Guid:Bootstrap", "GooglePlacesSettings:load_new", "GooglePlacesSettings", "GooglePlacesSettings:Guid", "GooglePlacesSettings:Update:Guid", "GooglePlacesSettings:Delete:Guid", "GooglePlacesSettings:Merged:Site:Guid", "GooglePlacesSettings:Merged:Product:Guid", "GooglePlacesSettings:Owner:*:Guid", "Files:Uploads:load_new", "Files:Uploads", "Files:Uploads:Guid", "Files:Uploads:Update:Guid", "Files:Uploads:Delete:Guid", "Files:Processing:Jobs:Guid", "Sbr:Submissions", "Sbr:Submissions:Guid", "Sbr:ActivityStatements:Get", "Sbr:ActivityStatements:Validate", "Sbr:ActivityStatements:Submit", "Blanks:Preview:All", "Blanks:Guid", "Blanks:Update:Guid", "Blanks:Create", "Server:Meta", "SitePages:Preview:All", "SitePages:Preview:Guid", "SitePages:Create", "SitePages:Update:Guid", "SitePages:Archive:Guid", "SitePages:Publish:Guid", "SitePages:RuntimeSnapshot"] as const;

/* Aliases */
export const Subject = AbilitySubject;
export const S = AbilitySubject;
